// Used by Firestore to define the database Setup collection

export type DbSetup = {
  setupUsers: boolean;
  setupDemoData: boolean;
  setupPerfLoad: boolean;
};
export type RunSetupRequest = {};

export type RunSetupResponse = {
  status: boolean;
  message: string;
};

export type ClearDataRequest = {};

export type ClearDataResponse = {
  status: boolean;
  message: string;
};
